import React, {useState} from 'react';
import wrap from 'wraptile';
import {curry} from 'ramda';
import CreateIcon from '@material-ui/icons/Create';

import PriorityQCModal from './PriorityQCModal';
import {
    ChangeJobPriorityAction,
    HandlePriorityChangeParams,
    Priorities,
    SelectChangeEvent,
    SetPriorityLevel,
    SetOpen,
    PriorityLevels,
} from '../../QCManagerTypes';
import {QCFilters} from '../../../QCFilters/QCFiltersType';

interface PrioritySingleQCModalContainerProps {
    jobId: number;
    title?: string;
    priority: number;
    changeQCJobPriority: ChangeJobPriorityAction;
    params: QCFilters;
}

export default function PriorityQCModalContainer(props: PrioritySingleQCModalContainerProps) {
    const {
        jobId,
        title,
        priority,
        changeQCJobPriority,
        params,
    } = props;
    const [open, setOpen] = useState<boolean>(false);
    const [singlePriorityLevel, setSinglePriorityLevel] = useState(priority);
    const onPrioritySelectChange = handleSelectChangePriority(setSinglePriorityLevel);
    const onPriorityPopupClose = handlePriorityPopupClose(setOpen);
    const getChecked = handleIsChecked(singlePriorityLevel);
    const onSinglePriorityChange = handlePrioritySingleChange({
        priorityValue: singlePriorityLevel,
        changeQCJobPriority,
        setOpen,
        jobId,
        params,
    });
    return (
        <div className="priority-block">
            {priority}
            <CreateIcon
                className="edit-icon"
                onClick={handlePriorityPopupOpen(setOpen)}
            />
            <PriorityQCModal
                open={open}
                title={title}
                getChecked={getChecked}
                handlePriorityClose={onPriorityPopupClose}
                handleSelectChangePriority={onPrioritySelectChange}
                handlePrioritySingleChange={onSinglePriorityChange}
                getCurrentPriorityLevel={getCurrentPriorityLevel}
                priority={priority}
            />
        </div>
    );
}

PriorityQCModalContainer.defaultProps = {
    title: '',
};

const handleIsChecked = curry((singlePriorityLevel: number, priorityValue: Priorities) => {
    return Number(singlePriorityLevel) === priorityValue;
});

export const handlePrioritySingleChange = wrap((handlers: HandlePriorityChangeParams) => {
    const {
        priorityValue,
        changeQCJobPriority,
        setOpen,
        jobId,
        params,
    } = handlers;
    
    const body = [{
        id: jobId,
        priority: Number(priorityValue),
    }];
    
    changeQCJobPriority(body, params);
    setOpen(false);
});

export const handlePriorityPopupOpen = wrap((setOpen: SetOpen) => {
    setOpen(true);
});

export const handlePriorityPopupClose = wrap((setOpen: SetOpen) => {
    setOpen(false);
});

export const handleSelectChangePriority = curry((setSinglePriorityLevel: SetPriorityLevel, e: SelectChangeEvent) => {
    setSinglePriorityLevel(e.target.value as Priorities);
});

export const getCurrentPriorityLevel = (priority: number) => {
    switch(priority) {
    case 1:
        return PriorityLevels.Highest;
    case 2:
        return PriorityLevels.High;
    case 3:
        return PriorityLevels.Medium;
    case 4:
        return PriorityLevels.Low;
    case 5:
        return PriorityLevels.Lowest;
    default:
        return PriorityLevels.Medium;
    }
};
